<template>
  <section>
    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-flex class="ml-0 " >
                  
                    <v-layout row >
                        <v-flex xs10  sm10  md6 lg6 xl6 class="header-table mt-3">
                          <v-flex offset-xs1 offset-sm1 offset-md1 offset-lg1 offset-xl1 >
                            <p class="display-1">Listado de Calificaciones</p>
                            
                          </v-flex>
                        </v-flex>
                        
                        <v-flex xs10  sm10  md6 lg6 xl6  class="header-table mt-3">
                          <v-flex offset-xs1 offset-sm5 offset-md7 offset-lg8 offset-xl8 >
                            <v-btn color="primary"  offset-xs8 offset-sm8 offset-md8 offset-lg8 offset-xl8  @click="volver()"><v-icon>arrow_back</v-icon>Volver</v-btn>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                        append-icon="search"
                        label="Buscador"
                        single-line
                        hide-details
                        v-model="search"
                      ></v-text-field>
                    </v-card-title>
                    <v-flex mx-5>
                    <v-data-table 
                        v-bind:headers="headers"
                        v-bind:items="pruebas"
                        v-bind:search="search"
                        rows-per-page-text = "Filas por Pagina"
                        no-data-text="No hay Evaluaciones"
                      >
                      <template slot="items" slot-scope="props">
                        
                        <td class="text-xs-center primary--text body-1">{{ props.item.section_title}}</td>
                        <td class="text-xs-center">{{ props.item.unity_name }}</td>
                        <td class="text-xs-center">{{ props.item.qualification_surrender_date}}</td>
                    
                        
                        <td class="text-xs-center">
                           <v-tooltip bottom>
                             <v-btn  slot="activator"  color="success" class="white--text"  @click="loadPrueba(props.item.id)" >
                            Calificar
                          </v-btn>
                              <span>Revisión de calificaciones</span>
                          </v-tooltip>
                          
                        </td>
                      </template>
                      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                        Desde {{ pageStart }} a {{ pageStop }}
                      </template>
                    </v-data-table>
                    </v-flex>
                  
                </v-flex>
        
        
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          
        </v-layout>
      </v-flex>
    </v-layout>


  </section>
</template>

<script>
import { courceService } from '@/services/Cource.service'
import { getQualificationPerCourseService } from '@/services/Calificacion/GetQualificationPerCourse.service'
import { getTestPerCourseService } from '@/services/prueba/GetTestPerCourse.service'

export default {
  data () {
    return {
      idCurso: 0,
      curso: 0,
      search: '',
      pagination: {},
      calificaciones: [],
      headers: [
        { text: 'Nombre', align: 'center', value: 'nombre' },
        { text: 'Unidad', align: 'center', value: 'ponderacion' },
        { text: '', align: 'center', value: 'fecha' },
        { text: 'Calificar alumnos', align: 'center', value: 'calificar' }
      ],
      isAyudante: false,
      pruebas: []
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.loadCurso()
    vm.loadCalificaciones()
    vm.loadPruebas()
  },
  methods: {
    loadCurso () {
      let vm = this
      courceService.getById(vm.idCurso).then(data => {
        vm.curso = data.body
      })
    },
    loadCalificaciones () {
      let vm = this
      getQualificationPerCourseService.getById(vm.idCurso).then(data => {
        vm.calificaciones = data.body
      })
    },
    loadPruebas () {
      let vm = this
      getTestPerCourseService.getById(vm.idCurso).then(data => {
        vm.pruebas = data.body
      })
    },
    loadPrueba (id) {
      this.$router.push({name: 'showCalificacion', params: {id: id}})
    },
    volver () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.circulo {
     width: 60px;
     height: 60px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: white;
}

.bordes {
  border-radius: 20px 20px 20px 20px;
-moz-border-radius: 20px 20px 20px 20px;
-webkit-border-radius: 20px 20px 20px 20px;
border: 0px solid #000000;
}
.enlace {
  text-decoration:none;
}
</style>


// WEBPACK FOOTER //
// src/components/Calificacion/ShowListQualification.vue